/*
 * @Author: zhangjun
 * @Date: 2023-06-25 16:35:02
 * @LastEditors: zhangjun
 * @LastEditTime: 2023-06-29 16:27:25
 * @Description: 国内埋点服务
 * @FilePath: /src/serverice/request-dc.js
 */
import axios from "axios";
const str = "dc-o.api.leiniao.com"; // 生产环境接口地址
let serviceBaseUrl = "";
const getUrl = () => str;

if (!location.origin) {
  location.origin = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
}
process.env.NODE_ENV === "production"
  ? location.origin.includes("test")
    ? (serviceBaseUrl = "https://dc-t.api.leiniao.com")
    : (serviceBaseUrl = `${location.protocol}//${getUrl()}`)
  : (serviceBaseUrl = "/dcApi");

const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: serviceBaseUrl, // url = base url + request url
  timeout: 5000, // request timeout
});

export default service;
